import { NpsMonthlyRequestDto } from '@/data/dto/nps/npsEvolutions.dto';

export default class DateUtil {
  static monthLabel(
    year: number,
    month: number,
    monthFormat: 'short' | 'long' = 'short'
  ): string {
    return new Date(year, month - 1)
      .toLocaleDateString('pt-BR', { month: monthFormat })
      .replace('.', '');
  }

  static capitalizedMonthLabel(year: number, month: number): string {
    const monthLabel = DateUtil.monthLabel(year, month, 'long');
    return monthLabel.charAt(0).toUpperCase() + monthLabel.slice(1);
  }

  static monthYearRangeLabel<T extends { year: number; month: number }>(
    data: T[]
  ): string {
    if (!data.length) return '';

    const year = Math.max(...data.map((item) => item.year));
    const lastMonth = Math.max(...data.filter((item) => item.year === year).map((item) => item.month));

    const capitalize = (label: string): string => label.charAt(0).toUpperCase() + label.slice(1);
    const start = capitalize(DateUtil.monthLabel(year, 1, 'short'));
    const end = capitalize(DateUtil.monthLabel(year, lastMonth, 'short'));

    return lastMonth === 1 ? ` (${start})` : ` (${start}-${end})`;
  }

  static lastTwelveMonthsRange(date = new Date()): NpsMonthlyRequestDto {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return {
      year,
      month,
    };
  }
}